import Vue from 'vue';
import Router from 'vue-router';
import routerInfo from './router';
import App from './App.vue';
import store from './store';
import { showBusinessError } from './fit-components/dialog/main';
import { rem, vueTap, request, registGlobalBiParam } from '@tencent/ppd-base-libs';
import { CustomException } from '@/utils/error';
import { initReport, report } from '@tencent/ppd-report-sdk-web';
import './i18n';
import webSDKCore from '@tencent/ti18n-websdkcore';
import Ti18nVueSDK from '@tencent/ti18n-vuesdk';
import axios from 'axios';
import { PlatformType } from './business/scene/type';
import { getEnv } from './business/client';
import { getWxOpenid } from './business/wx';

// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);
// 兜底错误展示
Vue.config.errorHandler = (err) => {
  new CustomException(err, 'defaultError', `兜底异常:${err.toString()}`);
  showBusinessError(err);
};

request.init(axios);

const tamUrl = 'https://ap-guangzhou-fit.log.zhiyan.tencent-cloud.net/collect';
const tamId = 'aegis-1efe5afbedcfee14';
// 初始化上报
initReport({
  id: tamId,
  hostUrl: { url: tamUrl },
  filterReportUrls: ['https://pingtas.qq.com'],
  filterMsgs: ['Script error.'],
  router,
  // @ts-ignore
  appEnv: process.env.VUE_APP_ENV,
  appVersion: process.env.VUE_APP_SENTRY_VERSION, // app版本号
  // @ts-ignore
  business: process.env.VUE_APP_PKGNAME,  // 区分业务，用于elk
  isReportPageStayedTime: true, // 是否上报页面停留时间
  bi: {
    reportNeedLogin: false,
    sid: '500735886',
    cid: '500735887',
    domain: 'weremit.tenpay.com',
  },
  // 判断环境 其实是uid
  isReportAfterSetUin: getEnv() === PlatformType.MOBILE_INSIDE_WX,
});

// 补充上报全局参数
report.setGlobalParams({
  target: process.env.VUE_APP_PKGNAME,
  version: process.env.VUE_APP_SENTRY_VERSION || 'local',
});

report.setConfig({
  uin: getWxOpenid() || 'unknow',
});

// 全局字段增加app版本号
registGlobalBiParam({
  version: process.env.VUE_APP_SENTRY_VERSION,
});

// 开启rem布局
rem();
// 开启vtap
Vue.use(vueTap);

Vue.config.productionTip = false;

// 多语言配置
// 注册Vue
Vue.use(Ti18nVueSDK);

const i18n = new Ti18nVueSDK(webSDKCore);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
